module.exports = __webpack_public_path__ + "static/media/2.13_preview.dd16e925.png";